import { Box } from "@mui/material";
import PropTypes from "prop-types";
import { forwardRef } from "react";

const MKBox = forwardRef(({ variant, bgColor, color, opacity, borderRadius, shadow, ...rest }, ref) => (
  <Box
    ref={ref}
    sx={{
      backgroundColor: bgColor,
      color: color,
      opacity: opacity,
      borderRadius: borderRadius,
      boxShadow: shadow,
      ...rest.sx,
    }}
    {...rest}
  />
));

MKBox.defaultProps = {
  variant: "contained",
  bgColor: "transparent",
  color: "dark",
  opacity: 1,
  borderRadius: "none",
  shadow: "none",
};

MKBox.propTypes = {
  variant: PropTypes.oneOf(["contained", "gradient"]),
  bgColor: PropTypes.string,
  color: PropTypes.string,
  opacity: PropTypes.number,
  borderRadius: PropTypes.string,
  shadow: PropTypes.string,
};

MKBox.displayName = "MKBox";

export default MKBox;

